<template>
    <fr-center-card  :showLogo="true">
        <b-card-body slot="center-card-body">
            <div slot="center-card-header">
                <h2 class="h2">{{$t('pages.selfservice.registration.registerYourAccount')}}</h2>
            </div>
            <br>
            <div>
                <b-alert variant="success" show>
                    <p>{{$t('pages.selfservice.registration.successfullyRegistered')}}</p>
                </b-alert>
                <div>
                  <a :href="gotoLink" id="sloginUrl" class="login-url" @click="backUrl">{{ $t('pages.selfservice.registration.success.goToUrlText')}}</a>
                </div>
            </div>
        </b-card-body>
    </fr-center-card>
</template>

<script>
import CenterCard from '@/components/utils/CenterCard';
/**
* @description Selfservice stage for password reset, handles the final result of password reset, either displaying an error or that the reset has been complete
*
**/
export default {
    name: 'success',
    components: {
        'fr-center-card': CenterCard
    },
    computed: {
        gotoLink () {
            if (this.$route.query.isLinkingAccounts === 'true' && this.$route.query.goto) {
                let gotoUrl = decodeURIComponent(this.$route.query.goto);
                // Replace first comma with & if present in the URL
                if (gotoUrl.includes(',')) {
                    gotoUrl = gotoUrl.replace(',', '&');
                }
                return gotoUrl;
            }
            return this.$route.query.goto;
        }
    },
    methods: {
        backUrl (event) {
            const goToUrl = this.$route.query.goto;
            if (!goToUrl) {
                event.preventDefault();
                window.location.assign(window.location.origin + '/auth/XUI/?realm=/pearson&service=AuthN#login/');
            }
        }
    }
};
window.gaEvent('Register', 'Register', 'Success', 'Register success');
</script>
<style scoped lang="scss">
@import '../../../scss/pearson-common.css';
</style>
